import { makeStyles } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import { Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  left: {
    height: 52,
    border: '2px dotted green',
    padding: 5
  },
  right: {
    height: 52,
    border: '2px dotted red',
    padding: 5
  },
  media: {
    height: 40,
    border: '1px solid #bbb',
    marginRight: 5
  },


}));

export default function SearchHitDepo() {
  const classes = useStyles();

  return <>
    <Grid container spacing={1}>
      <Grid xs={6} item={true} >
        <Container className={classes.left}>
          <img className={classes.media} src="/img/cont.png" alt="" />
          <img className={classes.media} src="/img/cont.png" alt="" />
          <img className={classes.media} src="/img/cont.png" alt="" />
          <img className={classes.media} src="/img/cont.png" alt="" />
        </Container>
      </Grid>
      <Grid xs={6} item={true}>
        <Container className={classes.right}>
          <img className={classes.media} src="/img/cont.png" alt="" />
          <img className={classes.media} src="/img/cont.png" alt="" />
        </Container>
      </Grid>
    </Grid>
  </>;
}